"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Snippet = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importStar(require("react"));
var react_aria_components_1 = require("react-aria-components");
var Flex_1 = require("../Flex");
var icons_1 = require("../icons");
var theme_1 = require("../theme");
var Buttons_1 = require("./Buttons");
var Form_1 = require("./Forms/Form");
var utils_1 = require("./utils");
var Container = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  padding: ", " ", ";\n  border: ", " solid ", ";\n  border-radius: ", ";\n  min-height: ", ";\n  min-width: 240px;\n  outline: none;\n  gap: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  background: ", ";\n  padding: ", " ", ";\n  border: ", " solid ", ";\n  border-radius: ", ";\n  min-height: ", ";\n  min-width: 240px;\n  outline: none;\n  gap: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])), theme_1.theme.colors.surface200, theme_1.theme.space.space8, theme_1.theme.space.space12, theme_1.theme.borderWidths.regular, theme_1.theme.colors.n70, theme_1.theme.radii.field, theme_1.theme.space.space48, theme_1.theme.space.space16);
var StyledInput = (0, styled_1.default)(react_aria_components_1.Input)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: ", ";\n  background: transparent;\n  color: ", ";\n  background-color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  border: none;\n  margin: 0;\n  &[data-focus-visible] {\n    outline: ", " solid ", ";\n    outline-offset: ", ";\n  }\n\n  flex-grow: 1;\n  outline: none;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  border-radius: ", ";\n"], ["\n  font-family: ", ";\n  background: transparent;\n  color: ", ";\n  background-color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  border: none;\n  margin: 0;\n  &[data-focus-visible] {\n    outline: ", " solid ", ";\n    outline-offset: ", ";\n  }\n\n  flex-grow: 1;\n  outline: none;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  border-radius: ", ";\n"])), theme_1.theme.fonts.mono, theme_1.theme.colors.n900, theme_1.theme.colors.surface200, theme_1.theme.fontSizes.code, theme_1.theme.lineHeights.code, theme_1.theme.borderWidths.thick, theme_1.theme.colors.blue400, theme_1.theme.space.space2, theme_1.theme.radii.rounded);
var HiddenSpan = styled_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  visibility: hidden;\n"], ["\n  visibility: hidden;\n"])));
var Snippet = function (_a) {
    var displayValue = _a.value, label = _a.label, showLabel = _a.showLabel, copyValue = _a.copyValue;
    var _b = (0, react_1.useState)(false), isCopied = _b[0], setIsCopied = _b[1];
    var clipboardProps = (0, utils_1.useClipboard)({
        getItems: function () {
            return [
                {
                    'text/plain': copyValue !== null && copyValue !== void 0 ? copyValue : displayValue,
                },
            ];
        },
    }).clipboardProps;
    var copyToClipboard = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.clipboard.writeText(copyValue !== null && copyValue !== void 0 ? copyValue : displayValue)];
                case 1:
                    _a.sent();
                    setIsCopied(true);
                    setTimeout(function () { return setIsCopied(false); }, 2500);
                    return [3 /*break*/, 3];
                case 2:
                    _error_1 = _a.sent();
                    setIsCopied(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', gap: 'space8' },
        showLabel ? react_1.default.createElement(Form_1.Label, null, label) : null,
        react_1.default.createElement(Container, null,
            react_1.default.createElement(StyledInput, __assign({ "aria-label": label, readOnly: true, value: displayValue }, clipboardProps)),
            react_1.default.createElement(Buttons_1.SecondaryButton, { isPending: isCopied, onPress: copyToClipboard }, isCopied ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(HiddenSpan, null, "Copy"),
                react_1.default.createElement(utils_1.VisuallyHidden, null, "Copied successfully"),
                react_1.default.createElement(icons_1.CheckIcon, { "aria-hidden": true, style: { position: 'absolute' }, size: 20 }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { "aria-hidden": true }, "Copy"),
                react_1.default.createElement(utils_1.VisuallyHidden, null,
                    "Copy ",
                    label,
                    " to clipboard")))))));
};
exports.Snippet = Snippet;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Snippet.js.map